/**
 * Promise-based confirm. Shows a global ConfirmDialog and resolves with true/false.
 *
 * Backed by a Pinia store (`useDialogStore`) — same reactivity pattern the
 * rest of the app uses (useUiStore, useSettingsStore, …). NO Composition
 * API: this codebase is locked to Options API everywhere, including
 * utility modules. Pinia stores ARE reactive without us touching `ref` /
 * `reactive` ourselves.
 *
 * Usage:
 *   if (await confirmDialog({ title: 'Stornieren?', message: '…', danger: true })) { ... }
 */
import { defineStore } from 'pinia';

export const useDialogStore = defineStore('dialog', {
    state: () => ({
        open: false,
        title: '',
        message: '',
        confirmLabel: 'Bestätigen',
        cancelLabel:  'Abbrechen',
        danger: false,
        // Promise resolver kept on the store so the singleton ConfirmDialog
        // component can fulfil it from a different call site than the one
        // that opened the modal.
        resolveFn: null,
    }),
    actions: {
        show(opts = {}) {
            return new Promise((resolve) => {
                this.title        = opts.title || 'Bestätigen';
                this.message      = opts.message || '';
                this.confirmLabel = opts.confirmLabel || (opts.danger ? 'Löschen' : 'Bestätigen');
                this.cancelLabel  = opts.cancelLabel || 'Abbrechen';
                this.danger       = !!opts.danger;
                this.resolveFn    = resolve;
                this.open         = true;
            });
        },
        resolve(answer) {
            if (this.resolveFn) this.resolveFn(answer);
            this.resolveFn = null;
            this.open = false;
        },
    },
});

/** Public API — same shape callers used before the Pinia move. */
export function confirmDialog(opts = {}) {
    return useDialogStore().show(opts);
}
